/* begin polyfills */
//import 'babel-polyfill';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js/features/array/find';
import 'core-js/features/array/includes';
import 'core-js/features/number/is-nan';
/* end of polyfills */

import 'bootstrap/dist/css/bootstrap.min.css'; //bootstrap
import 'assets/icons8Mobile/css/styles.min.css'; //icons8 mobile
import 'assets/icons8/css/styles.min.css'; //icons8

import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/app/app';
import './services/apiService';
import * as serviceWorker from './serviceWorker';
import './i18n';

require('dotenv').config();

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
